export interface AgencieStore {
    agencia: string;
    prioridad: number;
    almacenCodigo: number;
    almacenNombre: string;
    hora: number;
    minuto: number;
    fecha: string;
    rutaLogo: string;
}

export class AgencieStoreHelper {

    static create(): AgencieStore {
        return {
            agencia: '',
            prioridad: 0,
            almacenCodigo: 0,
            almacenNombre: '',
            hora: 0,
            minuto: 0,
            fecha: '',
            rutaLogo: ''
        };
    }

    static transformFromAPI(apiData: Object) {
        const obj = AgencieStoreHelper.create();
        obj.agencia = apiData['AGENCIA'];
        obj.prioridad = apiData['PRIORIDAD'];
        obj.almacenCodigo = apiData['ALMACEN_CODIGO'];
        obj.almacenNombre = apiData['ALMACEN_NOMBRE'];
        obj.hora = apiData['HORA'];
        obj.minuto = apiData['MINUTO'];
        obj.fecha = apiData['FECHA_ENTREGA'];
        obj.rutaLogo = apiData['RUTA_LOGO_AGENCIAS'];
        return obj;
    }
}
